import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_mst_label_link_RowClass} from '../../../dbschema';

export class InventoryLabelLinkContainerModel extends BaseContainerModel {
  bl_inv_mst_label_link: bl_inv_mst_label_link_RowClass = new bl_inv_mst_label_link_RowClass();
}
